import { Alert, CommonProp, IconButton, IconLinkOut, Loading, Text } from '@acin/ui-core';
import React from 'react';
import { useRegulation } from '../../RegulationProvider';
import { useInternalDocumentInstancesQuery } from '../graphql/queries/getDocumentsByRegulation.generated';
import * as SC from './DocumentsSwitcher.styled';

interface DocumentSwitcherProps extends CommonProp {
  regulationId: string;
}

export const DocumentSwitcher: React.FC<DocumentSwitcherProps> = (props) => {
  const { regulationId } = props;
  const { activeDocument, onUpdateShowDocumentModal, onUpdateActiveDocument, onUpdateDocumentsInitialised } =
    useRegulation();

  const {
    data: documentData,
    error: documentError,
    loading: documentLoading,
  } = useInternalDocumentInstancesQuery({
    variables: {
      input: {
        filters: {
          groups: [
            {
              groupKey: 'REGULATION_ID',
              filterValues: [
                {
                  value: regulationId,
                },
              ],
            },
          ],
        },
      },
    },
    fetchPolicy: 'network-only',
    onCompleted: (result) => {
      const docs = result.internalDocumentInstances.edges;

      if (docs.length === 1) {
        onUpdateActiveDocument(docs[0].node);
      }
      onUpdateDocumentsInitialised(true);
    },
  });

  if (documentLoading) {
    return <Loading />;
  }

  if (documentError) {
    return <Alert title="Error loading documents" status="error" />;
  }

  const handleClick = () => {
    onUpdateShowDocumentModal(true);
  };

  const handleOpenLink = () => {
    if (!!activeDocument?.documentUrl) {
      window.open(activeDocument.documentUrl, '_blank');
    }
  };

  const isSingleDocument = documentData?.internalDocumentInstances.edges.length === 1;
  const documentCode = activeDocument?.documentDisplayCode ?? activeDocument?.documentCode ?? '';

  return (
    <SC.DocumentSwitcher>
      {isSingleDocument ? (
        <SC.Document onClick={handleOpenLink} isSingle>
          <Text>View Full Regulation</Text>
        </SC.Document>
      ) : (
        <>
          <SC.Document onClick={handleClick}>
            <Text>Viewing:</Text>
            <SC.Name weight={600}>
              {activeDocument ? `${activeDocument.citation} ${documentCode}` : 'All Documents'}
            </SC.Name>
            <SC.Icon />
          </SC.Document>
        </>
      )}
      <IconButton
        onClick={handleOpenLink}
        disabled={!activeDocument?.documentUrl}
        size="small"
        label="View Source"
        icon={() => <IconLinkOut />}
      />
    </SC.DocumentSwitcher>
  );
};
